import { NavLink, Outlet } from 'react-router';
import { UpdatePrompt } from '@/features/pwa/UpdatePrompt';
import { StandaloneNotice } from '@/features/pwa/StandaloneNotice';
import { BackupBanner } from '@/features/backup/BackupBanner';

const NAVEGACION = [
  { ruta: '/', titulo: 'Hoy', icono: '🏠' },
  { ruta: '/pedidos', titulo: 'Pedidos', icono: '🧾' },
  { ruta: '/respaldos', titulo: 'Respaldos', icono: '💾' },
  { ruta: '/ajustes', titulo: 'Ajustes', icono: '⚙️' },
];

/**
 * Armazon de la aplicacion.
 *
 * Mobile-first: una sola columna, navegacion inferior alcanzable con el pulgar
 * (Req. 19.1, 19.4) y respeto de las areas seguras del iPhone (Req. 19.6).
 *
 * Los avisos de actualizacion, de almacenamiento separado y de respaldo
 * pendiente viven aqui para que se vean desde cualquier pantalla.
 */
export function Layout() {
  return (
    <div className="flex min-h-dvh flex-col bg-fondo">
      <a
        href="#contenido"
        className="sr-only focus:not-sr-only focus:absolute focus:left-2 focus:top-2 focus:z-50 focus:rounded-lg focus:bg-superficie focus:px-3 focus:py-2"
      >
        Ir al contenido
      </a>

      <main
        id="contenido"
        className="mx-auto w-full max-w-lg flex-1 space-y-4 px-4 pt-segura pb-28"
      >
        <div className="space-y-3 pt-4">
          <UpdatePrompt />
          <StandaloneNotice />
          <BackupBanner />
        </div>

        <Outlet />
      </main>

      <nav
        aria-label="Navegacion principal"
        className="fixed inset-x-0 bottom-0 border-t border-borde bg-superficie/95 backdrop-blur pb-segura"
      >
        <ul className="mx-auto flex w-full max-w-lg">
          {NAVEGACION.map((item) => (
            <li key={item.ruta} className="flex-1">
              <NavLink
                to={item.ruta}
                end={item.ruta === '/'}
                className={({ isActive }) =>
                  [
                    'flex min-h-14 flex-col items-center justify-center gap-0.5 py-2 text-xs font-medium',
                    isActive ? 'text-marca' : 'text-texto-suave',
                  ].join(' ')
                }
              >
                {({ isActive }) => (
                  <>
                    <span aria-hidden="true" className="text-xl leading-none">
                      {item.icono}
                    </span>
                    <span>{item.titulo}</span>
                    {/* Indicador que no depende solo del color (Req. 19.7) */}
                    <span className="sr-only">{isActive ? '(seccion actual)' : ''}</span>
                  </>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}
